import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  Typography,
  Paper,
  Button,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { useNotification } from "../../providers/NotificationProvider";
import { fetchCustomerCategories } from "../../api/memberApi";

export default function CustomerCategoryListPage() {
  const { businessDomainId, businessUnitId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchCustomerCategories(businessUnitId);
      setItems(Array.isArray(data) ? data : []);
    } catch (e) {
      notify.apiError(e);
    } finally {
      setLoading(false);
    }
  }, [businessUnitId]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    loadData();
  }, [loadData]);

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", mb: 3, gap: 2 }}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(`/strategy/${businessDomainId}/business-units/${businessUnitId}`)}
          variant="text"
        >
          {t("common.back")}
        </Button>
        <Typography variant="h5" sx={{ fontWeight: 600 }}>
          {t("customerCategory.list.title")}
        </Typography>
      </Box>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
          <CircularProgress />
        </Box>
      ) : items.length === 0 ? (
        <Typography color="text.secondary">{t("common.noData")}</Typography>
      ) : (
        <TableContainer component={Paper} variant="outlined">
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: "grey.50" }}>
                <TableCell sx={{ fontWeight: 600 }}>{t("customerCategory.name")}</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>{t("customerCategory.customerType")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map((row) => (
                <TableRow
                  key={row.customerCategoryId}
                  hover
                  sx={{ cursor: "pointer" }}
                  onClick={() =>
                    navigate(
                      `/strategy/${businessDomainId}/business-units/${businessUnitId}/customer-categories/${row.customerCategoryId}`
                    )
                  }
                >
                  <TableCell>{row.customerCategoryName || "—"}</TableCell>
                  <TableCell>{row.customerTypeName || "—"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
